var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKhatabook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.553 122.479H340.489C353.319 122.479 355.886 126.581 355.886 133.761V375.815C355.886 387.61 340.489 387.61 340.489 387.61L261.045 387.61L157.344 387.61C157.293 387.61 157.249 387.613 157.199 387.62C156.216 387.759 144.951 389.058 144.949 375.815C144.948 361.977 144.949 170.911 144.949 170.684V170.684V140.427C144.949 133.761 141.356 122.479 157.267 122.479H182.928H226.553Z",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.489 122.479C327.66 122.479 226.553 122.479 226.553 122.479C226.553 122.479 226.553 122.479 226.553 122.479H182.928C182.928 122.479 182.928 122.479 182.928 122.479C182.928 122.479 169.071 122.479 157.267 122.479C141.356 122.479 144.949 133.761 144.949 140.427C144.949 147.094 144.949 170.684 144.949 170.684C144.949 170.684 144.949 170.684 144.949 170.684C144.949 170.684 144.948 361.969 144.949 375.815C144.951 389.058 156.216 387.759 157.199 387.62C157.249 387.613 157.293 387.61 157.344 387.61L261.045 387.61L340.489 387.61C340.489 387.61 340.489 387.61 340.489 387.61C340.489 387.61 355.886 387.61 355.886 375.815C355.886 364.02 355.886 140.94 355.886 133.761C355.886 126.581 353.319 122.479 340.489 122.479Z",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.602,
    y1: 171.838,
    x2: 173.32,
    y2: 171.838,
    stroke: "black",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.602,
    y1: 198.505,
    x2: 173.32,
    y2: 198.505,
    stroke: "black",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.048 167.004H314.159C319.411 167.004 323.669 171.261 323.669 176.513V236.649C323.669 241.901 319.411 246.159 314.159 246.159H215.048C209.797 246.159 205.539 241.901 205.539 236.649V176.513C205.539 171.261 209.797 167.004 215.048 167.004Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.357 186.531H301.547C304.474 186.531 306.846 188.903 306.846 191.83V222.078C306.846 225.004 304.474 227.377 301.547 227.377H229.357C226.43 227.377 224.058 225.004 224.058 222.078V191.83C224.058 188.903 226.43 186.531 229.357 186.531Z",
    fill: "#4045A1",
    stroke: "black",
    strokeWidth: 6.61565
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.188,
    y1: 124.529,
    x2: 173.188,
    y2: 387.097,
    stroke: "black",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhatabook);
export default __webpack_public_path__ + "static/media/khatabook.a275e64f94268002d02b925f65562aa5.svg";
export { ForwardRef as ReactComponent };